module.exports = __webpack_public_path__ + "static/img/Boss_31083.260d1da0.png";